import { ILop } from "../../../model/response/category/ILop";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eLopActionsObj = {
    LOAD_START: undefined,
    LOAD_SUCCESS: {} as ILop[],
    LOAD_ERROR: "",
}

export const eLopActionIds = generateActionTypeIds(eLopActionsObj,"LOP");
export type ILopActionTypes = IGenericActionType<typeof eLopActionsObj,"LOP">;